import type { IconData } from '@stacksjs/iconify-core'

export const linkedin: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M165 90q0 35-21 59t-62 24q-37 0-59-24T0 95q0-35 23-61T83 8t60 24t22 58M0 750h165V214H0zm560-528q-32 0-57 8t-45 21t-33 27t-21 27h-4l-9-70H243q0 34 2 74t2 86v355h165V457q0-12 1-22t3-19q4-11 11-23t16-21t22-16t29-6q44 0 64 32t19 83v285h165V445q0-57-14-99t-38-70t-58-41t-72-13\"/>",
  "width": 750,
  "height": 850,
  "viewBox": "0 0 750 850"
}

export default linkedin
